import CryptoJS from 'crypto-js'

// Generate a random code verifier
export function generateCodeVerifier() {
  var codeVerifier = ''
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~'
  for (var i = 0; i < 128; i++) {
    codeVerifier += characters.charAt(
      Math.floor(Math.random() * characters.length)
    )
  }
  return codeVerifier
}

// Create a code challenge from the code verifier
export function generateCodeChallenge(codeVerifier) {
  var codeChallenge = CryptoJS.SHA256(codeVerifier)
    .toString(CryptoJS.enc.Base64)
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
  return codeChallenge
}
